import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const params: any = new URLSearchParams(window.location.search);
console.log("params", params.get('zone'))

if (params.get('zone')) {
  localStorage.setItem('lang', params.get('zone'))
}

const { locale } = useI18n()
// 初始化时从 localStorage 读取用户偏好
const savedLocale = localStorage.getItem('lang')
if (savedLocale) {
  locale.value = savedLocale
}


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_component_RouterView))
}
}

})